import {RecaptchaVerifier} from "firebase/auth";

import {AuthenticationRepository} from "../../../repositories/AuthenticationRepository";

export class SendPhoneVerificationCodeUseCase {
  constructor(private readonly repository: AuthenticationRepository) {}

  sendPhoneVerificationCode(phoneNumber: string, recaptchaVerifier: RecaptchaVerifier) {
    return this.repository.sendPhoneVerificationCode(phoneNumber, recaptchaVerifier)
  }
}
